import { useEffect, useMemo, useState } from 'react';
import { fitClass, tileLayout } from '../lib/wallGeometry';
import { StageProvider } from './stage';

const viewportSize = () => ({
  width: window.innerWidth,
  height: window.innerHeight,
});

/**
 * A video wall tile: children render onto the whole wall canvas (in canvas pixels), and this
 * screen shows only its slice of it, scaled to fit. Bezel gaps are canvas pixels no tile shows.
 */
export const WallStage = ({ wall, now, children }) => {
  const [viewport, setViewport] = useState(viewportSize);

  useEffect(() => {
    const onResize = () => setViewport(viewportSize());
    window.addEventListener('resize', onResize);
    return () => window.removeEventListener('resize', onResize);
  }, []);

  const { clip, canvas } = tileLayout(wall, viewport);

  const stage = useMemo(
    () => ({
      vh: (n) => `${(n / 100) * canvas.height}px`,
      vw: (n) => `${(n / 100) * canvas.width}px`,
      fitClass: fitClass(wall.fitMode),
      wall,
      now,
    }),
    [wall, now, canvas.width, canvas.height],
  );

  return (
    <div
      className="absolute overflow-hidden"
      style={{
        left: clip.left,
        top: clip.top,
        width: clip.width,
        height: clip.height,
      }}
    >
      <div
        className="absolute top-0 left-0 overflow-hidden"
        style={{
          width: canvas.width,
          height: canvas.height,
          transformOrigin: '0 0',
          transform: `scale(${canvas.scale}) translate(${-canvas.x}px, ${-canvas.y}px)`,
          '--pp-stage-width': `${canvas.width}px`,
        }}
      >
        <StageProvider value={stage}>{children}</StageProvider>
      </div>
    </div>
  );
};
